var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "d-flex h-100" }, [
    _c(
      "aside",
      { staticClass: "w-25 overflow-hidden" },
      [_c(_setup.ThemesEditorSidebar)],
      1
    ),
    _vm._v(" "),
    _c("main", { staticClass: "flex-fill w-100 overflow-hidden" }, [
      _c(
        "div",
        { staticClass: "d-flex flex-column h-100" },
        [
          _c(
            "div",
            {
              staticClass: "themes-editor-toolbar overflow-x-scroll",
              attrs: { "data-themes-editor-toolbar": "" },
            },
            [_c(_setup.ThemesEditorTabs)],
            1
          ),
          _vm._v(" "),
          _vm._l(_setup.editors, function (editor, index) {
            return index === _setup.activeEditorKey
              ? _c(
                  "div",
                  {
                    key: editor.key,
                    staticClass: "themes-editor--editor-container",
                  },
                  [
                    _c(_setup.ThemesEditorCodemirror, {
                      staticClass: "d-flex flex-column h-100",
                      attrs: {
                        editor: editor,
                        focused: editor.focused,
                        "latest-code": editor.latestCode,
                      },
                    }),
                  ],
                  1
                )
              : _vm._e()
          }),
        ],
        2
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }